import { render, staticRenderFns } from "./artileDetail.vue?vue&type=template&id=3f2be126"
import script from "./artileDetail.vue?vue&type=script&lang=js"
export * from "./artileDetail.vue?vue&type=script&lang=js"
import style0 from "./artileDetail.vue?vue&type=style&index=0&id=3f2be126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports